import React from "react";

// Non-blocking "Did you mean ...?" line shown under an email input.
// suggestion: full corrected email string, or falsy to render nothing.
// onAccept: called with the suggestion when the user clicks to accept it.
const EmailSuggestion = ({ suggestion, onAccept }) => {
  if (!suggestion) return null;
  return (
    <div className="email-suggestion">
      Did you mean{" "}
      <button
        type="button"
        className="email-suggestion-link"
        onClick={() => onAccept(suggestion)}
      >
        {suggestion}
      </button>
      ?
    </div>
  );
};

export default EmailSuggestion;
